import { render, staticRenderFns } from "./DepartmentCreateEditModal.vue?vue&type=template&id=131b557c"
import script from "./DepartmentCreateEditModal.vue?vue&type=script&lang=js"
export * from "./DepartmentCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports